import PageHero from "@/components/layout/PageHero";
import Testimonials from "@/components/sections/Testimonials";
import FinalCTA from "@/components/sections/FinalCTA";

const Depoimentos = () => (
  <>
    <PageHero
      eyebrow="O que nossos clientes dizem"
      title="Depoimentos"
      description="A satisfação dos nossos clientes é o nosso maior orgulho. Veja o que eles têm a dizer sobre nossos serviços."
    />
    <Testimonials showHeading={false} />
    <FinalCTA />
  </>
);

export default Depoimentos;
